import styled from 'styled-components';
import { Spinner } from '../Spinner';

export const LabelWrapper = styled.div`
  flex: 1;
  margin: 0 8px;
  font-size: 0.9rem;
`;

export const Container = styled.button<{ $iconPosition: 'left' | 'right' }>`
  position: relative;
  background-color: transparent;
  border: 0;
  outline: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 3px;
  padding: ${({ $iconPosition }) =>
    $iconPosition === 'left' ? '8px 0 8px 8px' : '8px 8px 8px 0'};

  & ${LabelWrapper} {
    order: ${({ $iconPosition }) => ($iconPosition === 'left' ? 1 : 0)};
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const IconContainer = styled.button`
  position: relative;
  background-color: transparent;
  border: 0;
  outline: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 3px;
  padding: 8px;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const Circle = styled.div<{ isLoading?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 1rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.lightBlue};
  font-size: 0.9rem;
  font-family: ${({ theme }) => theme.typography.primary.bold};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};

  > svg {
    width: 0.75rem;
    height: 0.75rem;
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const IconWrapper = styled.div<{ isLoading?: boolean }>`
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
  > svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: ${({ theme }) => theme.colors.lightBlue};
  }
`;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  left: -10px;
`;
